import React from 'react';
import Countdown from 'react-countdown';

function normalizeTimestamp(timestamp) {
  if (!timestamp) return null;
  return timestamp.substring(0, timestamp.length - 2).replace(' ', 'T');
}

function CountdownDisplay({ days, hours, minutes, seconds, completed }) {
  if (completed) return null;

  let text = '';
  if (days > 0) text = `${days} วัน ${hours} ชม. ${minutes} นาที`;
  else if (hours > 0) text = `${hours} ชม. ${minutes} นาที`;
  else if (minutes > 0) text = `${minutes} นาที ${seconds} วิ`;
  else text = `${seconds} วิ`;

  return <strong>{text}</strong>;
}

export default function DrawCountdown({ nextLottoTimestamp, variant = 'inline' }) {
  const date = normalizeTimestamp(nextLottoTimestamp);
  if (!date) return null;

  return (
    <Countdown
      date={date}
      renderer={(props) => {
        if (props.completed) return null;
        if (variant === 'hero') {
          return (
            <p className="draw-countdown-hero__timer" role="timer">
              งวดถัดไปใน <CountdownDisplay {...props} />
            </p>
          );
        }
        return (
          <p className="countdown-badge" role="timer">
            งวดถัดไปใน <CountdownDisplay {...props} />
          </p>
        );
      }}
    />
  );
}
